var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"color":"primary","dark":"","icon":""},on:{"click":_vm.toggleFeatured}},[(_vm.item.is_featured)?_c('v-icon',[_vm._v("mdi-star")]):_c('v-icon',[_vm._v("mdi-star-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }